import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-summary-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mb-lg-20" }
const _hoisted_4 = { class: "trezo-card-content" }
const _hoisted_5 = { class: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "mb-0" }, "Order Summary", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTimeframe) = $event)),
          class: "form-select month-select bg-gray border-0 form-control",
          "aria-label": "Default select example",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTimeframeChange && _ctx.onTimeframeChange(...args)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("option", { value: "Weekly" }, "Weekly", -1),
          _createElementVNode("option", { value: "Monthly" }, "Monthly", -1),
          _createElementVNode("option", { value: "Yearly" }, "Yearly", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.selectedTimeframe]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "donut",
                height: "321",
                options: _ctx.orderSummary,
                series: _ctx.series
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}